import $ from 'jquery';

const buttonEl = '.c-hamburger';
const navEl = '.nav';
const navSliderEl = '.nav__slider';
/**
 * undefined, 1 - mouse click, mobile device tap
 * 13 - keyboard enter code
 * 32 - keyboard space code
 * @type {*[]}
 */
const keyCodesAvailable = [undefined, 1, 13, 32];

$(document).on('click', buttonEl, (event) => {
  event.preventDefault();

  if (keyCodesAvailable.indexOf(event.keyCode) === -1) {
    return false;
  }

  $(buttonEl).toggleClass('open');
  $(buttonEl).find('.layer').toggleClass('open');

  if ($(buttonEl).hasClass('open')) {
    $(navEl).show();
    $(navSliderEl).slideDown(600);
  } else {
    $(navSliderEl).slideUp(600);
    setTimeout(() => {
      $(navEl).hide();
    }, 600);
  }
  return false;
});
